import { zodResolver } from '@hookform/resolvers/zod'
import { Grid } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Counterparty } from '~/shared/api'
import { CounterpartiesTypeEnum } from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'
import {
  AsyncAutocompleteInput,
  DatePickerInput,
  FormProvider,
  TextInput,
} from '~/shared/ui/Form'
import { PlusIcon } from '~/shared/ui/Icons'
import { formSchema, FormValues } from '../EditForm/model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onSuccess, isSubmitting }: FormProps) {
  const { t } = useTranslation()
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.insurer'
            name='counterpartyId'
            placeholder='form.select insurer'
            fetchOptions={(search: string) =>
              Counterparty.fetchOptionsByType(
                search,
                CounterpartiesTypeEnum.INSURANCE,
              )
            }
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.series'
            name='series'
            placeholder='form.enter series'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.number'
            name='number'
            placeholder='form.enter number'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.issue date'
            name='issuedDate'
            placeholder='form.select date'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.valid until'
            name='expirationDate'
            placeholder='form.select date'
            readOnly={isSubmitting}
          />
        </Grid>
      </Grid>
      <br />
      <Button
        loading={isSubmitting}
        startDecorator={<PlusIcon />}
        fullWidth
        type='submit'
      >
        {t('button.add')}
      </Button>
    </FormProvider>
  )
}
